export default function({ store, route, redirect }) {
  if (store.state.auth.loggedIn) {
    switch (route.path) {
      case '/login-page':
        redirect('/')
        break
      case '/registration-page':
        redirect('/')
        break
      case '/confirm-registration-page':
        redirect('/')
        break
    }
  } else if (!store.state.auth.loggedIn) {
    switch (route.path) {
      case '/user':
        redirect('/')
        break

      default:
        break
    }
  }
}



// WEBPACK FOOTER //
// ./middleware/auth.js